import { InfoOutlined } from '@mui/icons-material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AlertInfoTooltipView = function AlertInfoTooltipView(props) {
  var className = props.className,
      title = props.title,
      content = props.content,
      commonTextClassName = props.commonTextClassName;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('flex flex-row space-x-2', className),
    children: [/*#__PURE__*/_jsx(InfoOutlined, {
      className: clsx('mt-[2px] h-4 w-4', commonTextClassName || 'text-blue-secondary')
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col space-y-1",
      children: [/*#__PURE__*/_jsx("span", {
        className: clsx('text-sm font-bold', commonTextClassName || 'text-blue-secondary'),
        children: title
      }), content && /*#__PURE__*/_jsx("span", {
        className: clsx('text-xs font-medium', commonTextClassName || 'text-blue-secondary'),
        children: content
      })]
    })]
  });
};

export default AlertInfoTooltipView;